import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const projectSettingsCoreProformaJiraFormBuilderRoute: InvariantJiraRoute = {
	name: 'project-settings-core-proforma-jira-form-builder',
	path: '/jira/core/projects/:projectKey/settings/forms/form/:templateFormId/edit',
	exact: true,
};
